import { VolumeControlService } from '@gatho/services/audio/VolumeControlService';
import { BehaviorSubject } from "rxjs";

export class PeerVideoAudioControlService extends VolumeControlService {

  private muteSource = new BehaviorSubject<boolean>(false);
  $mute = this.muteSource.asObservable();

  constructor(peerUUID: string) {
    const volumeId = 'peer-'+ peerUUID;
    const defaultVolume = 50;
    super(volumeId, defaultVolume);
  }

  override getLocalStorageValue() {
    // saved peer volume value overrides saved main volume value
    const savedPeerVolume = super.getLocalStorageValue();
    if (savedPeerVolume) {
      return savedPeerVolume;
    }
    const allPeerVolume = localStorage.getItem('volume-peer-all');
    if (allPeerVolume) {
      return Number.parseInt(allPeerVolume, 10);
    }
    return null;
  }

  clearSavedPeerVolumeValues(): void {
    const re = /volume-peer-[\da-f]{8}-[\da-f]{4}-[\da-f]{4}-[\da-f]{4}-[\da-f]{12}/i;
    Object.entries(localStorage)
      .filter(k => re.exec(k[0]))
      .map(p => localStorage.removeItem(p[0]));
  }

  toggleMuteAllPeers(isMuted: boolean): void {
    this.muteSource.next(isMuted);
  }
}
